export const COLOR_MAIN = "#74052f"